import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderIcon from '@mui/icons-material/Folder';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

function TreeFolderNode({ name, itemCount, depth, isOpen, hasContent, onToggle, actions, avatarUrl, avatarFallback, children, keepMounted = false }) {
  return <Box sx={{ position: 'relative', ml: depth > 0 ? 1 : 0, pl: depth > 0 ? 1 : 0, borderLeft: depth > 0 ? '1px solid #c7c7c7' : 'none', '&::before': depth > 0 ? { content: '""', position: 'absolute', top: 28, left: -1, width: 8, borderTop: '1px solid #c7c7c7' } : undefined }}>
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 0.5 }}><Button onClick={onToggle} color="inherit" sx={{ flex: 1, minWidth: 0, justifyContent: 'flex-start', textTransform: 'none', pl: 1, gap: 0.5 }}>
      {hasContent ? <Box sx={{ display: 'flex', alignItems: 'center' }}>{isOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}</Box> : <Box sx={{ width: 24 }} />}
      <FolderIcon sx={{ color: '#d8a62b' }} />{avatarUrl !== undefined && <Avatar src={avatarUrl || undefined} sx={{ width: 28, height: 28, fontSize: '0.8rem' }}>{avatarFallback?.[0]?.toUpperCase()}</Avatar>}<Typography noWrap sx={{ flex: 1, textAlign: 'left' }}>{name}{typeof itemCount === 'number' ? ` (${itemCount})` : ''}</Typography>
    </Button>{actions}</Box>
    {(isOpen || keepMounted) && <Box sx={{ display: isOpen ? 'block' : 'none' }}>{children}</Box>}
  </Box>;
}

export default TreeFolderNode;
